import React from "react";

export default function Select({ options, selected = 0, onChange }) {
  return (
    <div className="select-wrapper">
      <select
        onChange={(e) => onChange(e.currentTarget.value)}
        value={selected}
      >
        {options.map((opt, index) => (
          <option key={index} value={index}>
            {opt.title}
          </option>
        ))}
      </select>
    </div>
  );
}
